import './Hero.css';
import Nav from './Nav';
import pan from '../assets/cutouts/pan.png';
import plateLeft from '../assets/cutouts/plate-2.png';
import plateRight from '../assets/cutouts/plate-3.png';
import { ReactComponent as PanLogo } from '../assets/logo/insane-vegan-logo.svg';

function Hero() {
  return (
    <section className="Hero">
      <Nav />

      <img className="Hero-plate Hero-plate--left" src={plateLeft} alt="" />
      <img className="Hero-plate Hero-plate--right" src={plateRight} alt="" />

      <h1 className="Hero-headline">
        <span className="Hero-headline-half">CHAOS?</span>
        <span className="Hero-headline-half">EAT UP.</span>
      </h1>

      <div className="Hero-panWrap">
        <svg
          className="Hero-arcText"
          viewBox="0 0 900 420"
          aria-hidden="true"
        >
          {/*
            True circle matching the pan bowl's own rim geometry (center/
            radius derived from alpha-scanning pan.png's opaque bowl pixels,
            converted into this SVG's local coordinate space), rather than an
            independent bezier — so the text visibly hugs/overlaps the pan's
            rim the way the reference design does, instead of floating above
            it on a shallower arc.
          */}
          <path
            id="handleArc"
            d="M 28.9,525.0 A 427,427 0 0,1 870.1,525.0"
            fill="none"
          />
          {/*
            Two separate text runs on the same arc, split around the pan
            handle so the physical handle stands in for the missing "l" in
            "handle" (see the build plan's callout on this). Gap tuned
            visually against the pan image, not derived from a formula.
          */}
          <text>
            <textPath href="#handleArc" startOffset="1.5%">
              We&rsquo;ll hand
            </textPath>
          </text>
          <text>
            <textPath href="#handleArc" startOffset="53.7%">
              e the fire.
            </textPath>
          </text>
        </svg>
        <img className="Hero-pan" src={pan} alt="" />
        <PanLogo className="Hero-panLogo" aria-hidden="true" />
      </div>
    </section>
  );
}

export default Hero;
